import { useFeatureFlag } from '@/context/FeatureFlagProvider';
import { AppliedSearchParams, useAccountSearchResults } from './accountSearch';
import { useAccountSearchResultsV2 } from './accountSearchv2';

/**
 * Wrapper hook that conditionally uses either useAccountSearchResults or useAccountSearchResultsV2
 * based on the meta5507CatalogElasticsearch feature flag.
 */
export const useAccountSearchResultsWrapper = ({
  accountId = 0,
  filter,
  pageSize = 50,
  after,
  pause,
}: AppliedSearchParams) => {
  const meta5507CatalogElasticsearch = useFeatureFlag(
    'meta5507CatalogElasticsearch',
    false,
  );

  const searchQueryV1 = useAccountSearchResults({
    accountId,
    filter,
    pageSize,
    after,
    pause: pause || meta5507CatalogElasticsearch,
  });

  const searchQueryV2 = useAccountSearchResultsV2({
    accountId,
    filter,
    pageSize,
    after,
    pause: pause || !meta5507CatalogElasticsearch,
  });

  // Return the active query based on the feature flag
  return meta5507CatalogElasticsearch ? searchQueryV2 : searchQueryV1;
};
